import type { BalancePostingSpec } from '@festina/life-general-types/life'
import { Button } from '@festina-life/ui/actions'
import { useTranslate } from '@festina-life/ui/hooks'
import { useState } from 'react'

import { BalancePostingSpecModal } from './BalancePostingSpecModal'

type Props = {
  onSubmit: (balancePostingSpec: BalancePostingSpec) => void
}

export const BalancePostingSpecTableAction = ({ onSubmit }: Props) => {
  const translate = useTranslate()
  const [isOpen, setIsOpen] = useState(false)

  const handleClose = () => {
    setIsOpen(false)
  }

  const handleSubmit = (balancePostingSpec: BalancePostingSpec) => {
    onSubmit(balancePostingSpec)
    handleClose()
  }

  return (
    <>
      {isOpen && (
        <BalancePostingSpecModal
          onSubmit={handleSubmit}
          onClose={handleClose}
        />
      )}
      <Button onClick={() => setIsOpen(true)}>
        {translate('action.addBalancePosting.title')}
      </Button>
    </>
  )
}
